import type { Session } from '../types';
import { tokens as fmt } from '../lib/format';
import { CHANNEL_ICON } from './statusMeta';
import { Icon } from './Icon';
import { OriginMark } from './OriginMark';
import { RelativeTime } from './RelativeTime';
import { StatusPill } from './StatusPill';

const WAITING = ['awaiting_human', 'awaiting_clarification', 'blocked'];

export function ConversationRow({
  s,
  onOpen,
  preview,
}: {
  s: Session;
  onOpen: () => void;
  preview: string;
}) {
  const waiting = WAITING.includes(s.state);
  const isQuestion =
    s.pending &&
    (s.pending.kind === 'question' ||
      s.pending.kind === 'clarification' ||
      s.pending.kind === 'rendezvous');
  return (
    <div
      onClick={onOpen}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onOpen();
      }}
      style={{
        height: 76,
        background: 'var(--panel)',
        border: '1px solid var(--border)',
        borderLeft: waiting ? '3px solid var(--warn)' : '1px solid var(--border)',
        borderRadius: 'var(--r-xl)',
        padding: '0 16px',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Icon name={CHANNEL_ICON[s.origin]} size={14} color="var(--faint)" />
        <span
          style={{ width: 6, height: 6, borderRadius: '50%', background: s.color, flex: 'none' }}
        />
        <span
          className="trunc"
          style={{
            flex: 1,
            font: waiting ? '600 15px/20px var(--font-ui)' : '400 15px/20px var(--font-ui)',
          }}
        >
          {s.title}
        </span>
        {s.queued.length > 0 && (
          <span
            title={s.queued
              .slice(0, 2)
              .map((q) => q.text)
              .join(' · ')}
            style={{
              height: 18,
              padding: '0 6px',
              borderRadius: 'var(--r-full)',
              background: 'var(--neutral-soft)',
              color: 'var(--dim)',
              font: '500 12px/18px var(--font-ui)',
              whiteSpace: 'nowrap',
            }}
          >
            {s.queued.length} in coda
          </span>
        )}
        {s.improvised && <OriginMark kind="improvised" reason={s.improvisedReason ?? ''} />}
        <StatusPill state={s.state} size="sm" />
        <RelativeTime at={s.updatedAt} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span
          className="trunc t-small dim"
          style={{ flex: 1, fontStyle: isQuestion ? 'italic' : 'normal' }}
        >
          {preview}
        </span>
        <span className="t-num dim" style={{ whiteSpace: 'nowrap' }}>
          {fmt(s.tokens)} · {s.instances} {s.instances === 1 ? 'istanza' : 'istanze'}
        </span>
      </div>
    </div>
  );
}
